import { WHITE } from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGE } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';
import { EVENT_OFFSET_TOP, TIME_TABLE_OFFSET_TOP } from '~/Screens/Calendar/constants';

export const useStyles = makeStyles(() => ({
  dayContainer: {
    width: '100%',
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
  },
  header: {
    fontSize: FONT_SIZE_LARGE,
    backgroundColor: WHITE,
    padding: '16px 0',
    position: 'sticky',
    top: 0,
  },
  dayTimings: {
    height: '100%',
    width: '100%',
    display: 'flex',
    marginTop: TIME_TABLE_OFFSET_TOP + EVENT_OFFSET_TOP,
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  },
  days: {
    position: 'absolute',
    top: 0,
    minHeight: '100%',
    minWidth: '100%',
  },
}));
